const INTERNAL_ERROR_PATTERNS = [
  /failed query/i,
  /params:/i,
  /tenant\/user/i,
  /postgres/i,
  /supabase/i,
  /database/i,
  /sql/i,
  /emaxconn/i,
  /max clients/i,
  /pool_size/i,
];

export function displayErrorMessage(message: string | null | undefined): string {
  if (!message) return 'Something went wrong. Please try again.';
  if (INTERNAL_ERROR_PATTERNS.some((pattern) => pattern.test(message))) {
    return 'Cloud service is temporarily unavailable. Your cached work is still visible.';
  }
  return message;
}
